import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/completed.png'


const _hoisted_1 = {
  key: 0,
  class: "text-xs text-gray-700 font-medium truncate"
}
const _hoisted_2 = {
  key: 0,
  class: "text-xs text-gray-700 font-medium truncate"
}
const _hoisted_3 = {
  key: 1,
  class: "py-2"
}
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = {
  key: 0,
  class: "absolute z-10 top-0 right-0"
}
const _hoisted_6 = { class: "aspect-w-16 aspect-h-9" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.video)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_ctx.video.role)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.video.role.name), 1))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.video.role_slug === 'default_history_qa')
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, "過去の質疑応答"))
                : _createCommentVNode("", true),
              (_ctx.video.role_slug === 'default')
                ? (_openBlock(), _createElementBlock("div", _hoisted_3))
                : _createCommentVNode("", true)
            ], 64)),
        _createElementVNode("div", _hoisted_4, [
          (Array.isArray(_ctx.video.video_completions) && _ctx.video.video_completions.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("img", {
                  class: "pt-1 pr-1 w-8",
                  src: _imports_0,
                  alt: "済"
                }, null, -1)
              ]))]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.thumbnailUrl === undefined)
              ? (_openBlock(), _createElementBlock("iframe", {
                  key: 0,
                  loading: "lazy",
                  src: _ctx.video.embed_url,
                  frameborder: "0",
                  class: "pointer-events-none w-full"
                }, null, 8, _hoisted_7))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  loading: "lazy",
                  src: _ctx.thumbnailUrl,
                  alt: "thumbnail",
                  class: "w-full"
                }, null, 8, _hoisted_8))
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(`text-gray-700 text-sm font-medium truncate mt-1 ${_ctx.titleAlign}`)
          }, _toDisplayString(_ctx.video.title), 3)
        ])
      ], 64))
    : _createCommentVNode("", true)
}